import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort, } from '../../../shared/utility';
import { chenthoorLandscapeLogo, lightningHandLogo, shamalAzzourLogo, ministryLogo, newKuwaitLogo, boldArabicFont, securityStamp, securityPositionFalah, securitySignatureFalah, securityPositionAnezi, securitySignatureAnezi, securityPositionJaseer, securitySignatureJaseer } from '../../../shared/fontsAndBitImages';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { DROPDOWN_CONFIG, CAMPAIGN_ID } from '../../../shared/Config';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Fieldset } from 'primereact/fieldset';
import AZNLogo from '../../../assets/images/AZN LOGO .jpg';
import Attachments from '../../../shared/UI/Attachments/Attachments';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import lodash from 'lodash';


// const Inputs = ({ field, metaData, onInputChange, type, ...props }) => {
//     const Component = ImplementationFor[parseInt(field.fieldType)] || false;

//     return Component && <Component
//         {...field}
//         {...props}
//         name={field.fieldName}
//         label={field.fieldDescription}
//         placeholder={field.fieldDescription}
//         onInputChange={onInputChange}
//         dateFormat={field.dateFormat}
//         view={field.view}
//         metaData={Object.assign({}, metaData, { "TA Request Number": props.TARequestNumber })}
//     /> || null;

// };


const TIME_FIELDS = ['start time', 'end time'];
const TIME_FORMATS = ['HH:mm', 'HH:mm:ss', 'hh:mm A', 'h:mm A'];
const isTimeField = (field) => TIME_FIELDS.includes(String(field.fieldDescription || '').trim().toLowerCase());
// Date-typed fields (7/8) that are not rendered as time pickers
const isDateField = (field) => (String(field.fieldType) === '7' || String(field.fieldType) === '8') && !isTimeField(field);

// Time picker for the Start Time / End Time fields; the value is kept as an 'HH:mm' string
const TimePickerBox = ({ field, onInputChange }) => {
    const parsed = field.fieldValue ? moment(field.fieldValue, TIME_FORMATS, true) : null;
    const display = field.fieldStatus && field.fieldStatus === 'Display Only';
    return (
        <div className="p-col-12">
            {!display ? <label className="label">{field.fieldDescription}</label> : null}
            <div className={display ? "mt3" : "mt1"}>
                {display ?
                    <div> {field.fieldDescription}: {field.fieldValue}</div> :
                    <Calendar
                        placeholder={field.fieldDescription}
                        value={parsed && parsed.isValid() ? parsed.toDate() : null}
                        name={field.fieldName}
                        disabled={field.disabled}
                        onChange={(e) => onInputChange({
                            preventDefault: () => { },
                            target: { name: field.fieldName, value: e.value ? moment(e.value).format('HH:mm') : '' }
                        })}
                        style={{ width: '100%' }}
                        timeOnly={true}
                        showTime={true}
                        hourFormat="24"
                        readOnlyInput={true} />
                }
            </div>
        </div>
    );
};

const Inputs = ({ field, metaData, onInputChange, type, ...props }) => {
    if ([1, 7, 8].includes(parseInt(field.fieldType)) && isTimeField(field)) {
        return <TimePickerBox field={field} onInputChange={onInputChange} />;
    }

    const Component = ImplementationFor[parseInt(field.fieldType)] || false;

    if (!Component) {
        return null;
    }

    return (
        <Component
            {...field}
            {...props}
            name={field.fieldName}
            label={field.fieldDescription}
            placeholder={field.fieldDescription}
            value={field.fieldValue == null ? '' : field.fieldValue}
            onInputChange={onInputChange}
            dateFormat={field.dateFormat}
            view={field.view}
            metaData={Object.assign({}, metaData, {
                "TA Request Number": props.TARequestNumber
            })}
        />
    );
};
let currentYear = new Date().getFullYear();
let value = [];
value.push({ label: currentYear, value: currentYear });
for (var i = currentYear; i > (currentYear - 5); i--) {
    value.push({ label: i - 1, value: i - 1 });
}
const year = value;
const currencyList = [
    { "label": "INR", "value": "INR", "id": "INR" },
    { "label": "KWD", "value": "KWD", "id": "KWD" },
    { "label": "SAR", "value": "SAR", "id": "SAR" },
    { "label": "USD", "value": "USD", "id": "USD" },
    { "label": "AED", "value": "AED", "id": "AED" },
    { "label": "EUR", "value": "EUR", "id": "EUR" },
    { "label": "OMR", "value": "OMR", "id": "OMR" },
    { "label": "BHD", "value": "BHD", "id": "BHD" },
    { "label": "GBP", "value": "GBP", "id": "GBP" },
    { "label": "CAD", "value": "CAD", "id": "CAD" },
    { "label": "CHF", "value": "CHF", "id": "CHF" },
    { "label": "DZD", "value": "DZD", "id": "DZD" },
    { "label": "IQD", "value": "IQD", "id": "IQD" },
    { "label": "JOD", "value": "JOD", "id": "JOD" },
    { "label": "PKR", "value": "PKR", "id": "PKR" },
    { "label": "PHP", "value": "PHP", "id": "PHP" },
    { "label": "JPY", "value": "JPY", "id": "JPY" }];

class MarketingCampaign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: '',
            month: '',
            year: '',
            loading: true,
            process: [],
            initialData: {},
            progressStarted: false,
            payslipGenerated: false,
            stageSequence: 0,
            month: false,
            year: false,
            requestDate: moment(),
            requestedFor: false,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            popupType: 'submit',
            requestattachments: [],
        }
        this.handleContainer = this.handleContainer.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value } = e.target;

        const updatedProcess = this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => {
            // First pass: update the changed field
            let updatedStageField = stage.stage_Field.map(field =>
                Object.assign({}, { ...field }, { fieldValue: field.fieldName === name ? value : field.fieldValue })
            );

            // Second pass: check if we need to recalculate Installment Amount
            const changedField = updatedStageField.find(f => f.fieldName === name);

            if (changedField && (changedField.fieldDescription === 'Requested Amount' || changedField.fieldDescription === 'Number Of Installments')) {
                // Find all the fields we need
                const requestedAmountField = updatedStageField.find(f => f.fieldDescription === 'Requested Amount');
                const numberOfInstallmentsField = updatedStageField.find(f => f.fieldDescription === 'Number Of Installments');
                const installmentAmountField = updatedStageField.find(f => f.fieldDescription === 'Installment Amount');

                // Calculate if all fields exist and have valid values
                if (installmentAmountField && requestedAmountField && numberOfInstallmentsField) {
                    const requestedAmount = requestedAmountField.fieldValue;
                    const numberOfInstallments = numberOfInstallmentsField.fieldValue;

                    if (requestedAmount && numberOfInstallments && numberOfInstallments != 0) {
                        const installmentAmount = (parseFloat(requestedAmount) / parseFloat(numberOfInstallments)).toFixed(2);

                        // Update the installment amount field
                        updatedStageField = updatedStageField.map(field =>
                            field.fieldDescription === 'Installment Amount' ?
                                Object.assign({}, { ...field }, { fieldValue: installmentAmount }) :
                                field
                        );
                    }
                }
            }

            return Object.assign({}, { ...stage }, { stage_Field: updatedStageField });
        });

        this.setState({
            process: updatedProcess,
            payslipGenerated: false
        });
    }

    handleMultiSelectChange = (e, el) => {
        const { name, value } = e.target;
        const fieldValue = Array.isArray(value) ? value.join(',') : value;

        const updatedProcess = this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
            stage_Field: stage.stage_Field.map(field =>
                Object.assign({}, { ...field }, { fieldValue: field.fieldName === name ? fieldValue : field.fieldValue })
            )
        }));

        this.setState({
            process: updatedProcess,
            payslipGenerated: false
        });
    }

    actionTemplate = (rowData) => {
        return (
            <Button type="button" icon="pi pi-pencil" className="p-button-primary"
                onClick={() => this.startEdit(rowData)} />
        );
    }

    // Reverts any un-updated edits of the row currently being edited back to its snapshot
    restoreEditSnapshot = () => {
        const { editSnapshot, process } = this.state;
        if (!editSnapshot) return process;
        const original = editSnapshot.reduce((o, f) => Object.assign(o, { [f.fieldName]: f.fieldValue }), {});
        return process.map(stage => Object.assign({}, stage, {
            stage_Field: stage.stage_Field.map(f => f.fieldName in original ? Object.assign({}, f, { fieldValue: original[f.fieldName] }) : f)
        }));
    }

    // The DataTable keeps showing the snapshot of the row until Update is clicked
    startEdit = (rowData) => {
        this.setState({
            process: this.restoreEditSnapshot(),
            editing: { parentFieldId: rowData.parentFieldId, childRowNmbr: rowData.childRowNmbr },
            editSnapshot: rowData.stage_Field
        });
    }

    updateEdit = () => {
        const { editing, process } = this.state;
        if (editing) {
            // Validate the fields of the row being edited (current values live in state.process)
            const editedRow = [];
            process.forEach(stage => (stage.stage_Field || []).forEach(f => {
                if (f.parentFieldId === editing.parentFieldId && String(f.childRowNmbr) === String(editing.childRowNmbr)) {
                    editedRow.push(f);
                }
            }));
            const missingFields = [];
            arraySort(editedRow, 'fieldSequence').forEach(el => {
                const isTime = [1, 7, 8].includes(parseInt(el.fieldType)) && isTimeField(el);
                if (!el.fieldDescription || !(isTime || ImplementationFor[parseInt(el.fieldType)])) {
                    return;
                }
                const val = el.fieldValue;
                const isEmpty = val === null || val === undefined || (Array.isArray(val) ? val.length === 0 : String(val).trim() === '');
                if (isEmpty && !missingFields.includes(el.fieldDescription)) {
                    missingFields.push(el.fieldDescription);
                }
            });
            if (missingFields.length > 0) {
                this.setState({ requiredFieldsMessage: `Please fill in the following required fields: ${missingFields.join(', ')}.` });
                return;
            }
        }
        this.setState({ editing: false, editSnapshot: null });
    }

    cancelEdit = () => this.setState({ process: this.restoreEditSnapshot(), editing: false, editSnapshot: null });

    rowExpansionTemplate = (data) => {
        try {
            const { metaData = {} } = this.props;

            const rowFieldsData = (data.stage_Field || []).map(field => {
                const dropdownValue = metaData[field.fieldDescription] && field.fieldValue && metaData[field.fieldDescription].find(_ => _.value === field.fieldValue);
                const value = (dropdownValue && dropdownValue.label) || ((field.fieldType === '7' || field.fieldType === '8') && field.fieldValue && moment(field.fieldValue).format('MM/DD/YYYY')) || field.fieldValue;
                return { label: field.fieldDescription, key: field.fieldName, value };
            });

            const rowsOfThree = rowFieldsData.reduce((rows, fieldItem, index) => {
                const rowIndex = Math.floor(index / 3);
                rows[rowIndex] = rows[rowIndex] || [];
                rows[rowIndex].push(fieldItem);
                return rows;
            }, []);

            return (
                <div className="p-fluid" style={{ padding: '2em 1em 1em 1em' }}>
                    {rowsOfThree.map((rowFields, rowIndex) => (
                        <div
                            key={rowIndex}
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                borderBottom: '1px solid #e0e0e0',
                                padding: '0.75em 0',
                            }}
                        >
                            {rowFields.map(({ label, key, value }, colIndex) => (
                                <div
                                    key={key}
                                    style={{
                                        flex: '1 1 200px',
                                        minWidth: '200px',
                                        padding: '0 1em',
                                        borderRight: colIndex < rowFields.length - 1 ? '1px solid #e0e0e0' : 'none',
                                    }}
                                >
                                    <span>{label}: </span>
                                    <span style={{ fontWeight: 'bold' }}>
                                        {value == null ? '' : value}
                                    </span>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            );
        }
        catch (error) {
            this.setState({ error: error })
        }
    }

    setFieldValueUsingFieldId(inputFieldId, process, valueToBeSet) {
        try {
            const { stageSequence } = this.state;

            const updatedProcess = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldId ? valueToBeSet : field.fieldValue })
                    })
            }))

            return updatedProcess
        }
        catch (error) {
            this.setState({ error: error })
        }
    }

    setFieldValueUsingFieldidrownum(inputFieldid, process, valueToBeSet, childRowNmbr) {

        try {
            const { stageSequence } = this.state;

            const updatedProcess = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldid && field.childRowNmbr == childRowNmbr ? valueToBeSet : field.fieldValue })
                    })
            }))

            return updatedProcess
        }
        catch (error) {
            this.setState({ error: error })
        }
    }

    handleContainer = (field) => {
        try {
            // Validate the container's input row (the last child row, as rendered) before adding
            const containerStage = this.state.process.find(stage => (stage.stage_Field || []).some(_ => _.fieldName === field.fieldName));
            const containerGroup = containerStage ? lodash.groupBy(containerStage.stage_Field.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr') : {};
            const groupKeys = Object.keys(containerGroup);
            const inputRow = groupKeys.length > 0 ? containerGroup[groupKeys[groupKeys.length - 1]] : [];
            const missingFields = [];
            arraySort(inputRow, 'fieldSequence').forEach(el => {
                const isTime = [1, 7, 8].includes(parseInt(el.fieldType)) && isTimeField(el);
                if (!el.fieldDescription || !(isTime || ImplementationFor[parseInt(el.fieldType)])) {
                    return;
                }
                const val = el.fieldValue;
                const isEmpty = val === null || val === undefined || (Array.isArray(val) ? val.length === 0 : String(val).trim() === '');
                if (isEmpty && !missingFields.includes(el.fieldDescription)) {
                    missingFields.push(el.fieldDescription);
                }
            });
            if (missingFields.length > 0) {
                this.setState({ requiredFieldsMessage: `Please fill in the following required fields: ${missingFields.join(', ')}.` });
                return;
            }

            this.setState({ loading: true, ifaddupdatepressed: 1 });
            const { process, stageSequence } = this.state;
            const { location } = this.props;
            let cldr = field.childRowNmbr;
            let flag = 0;
            let vcategory = '';

            let kwdtotalAmount = parseFloat(0.000).toFixed(3);

            let dummy = this.state.process.filter((element, index) => index == 0).map((el) => {
                return el.stage_Field.map((el) => {
                    if (el.fieldDescription === 'Description' && (el.fieldValue === "0" || el.fieldValue === "")) {
                        this.setState({ loading: false });
                        this.growl.show({ severity: 'error', summary: null, detail: 'please enter description' });
                        flag = 1;
                        return;
                    }
                    if (el.fieldDescription === 'Category') {
                        vcategory = el.fieldValue;

                    }
                    if (el.fieldDescription === 'Family Members' && el.fieldValue === null && (vcategory.toUpperCase() === '30A406ED-4C28-4639-84CD-BF30812F14BA' || vcategory.toUpperCase() === '30A406ED-4C28-4639-84CD-BF30812F13BA')) {
                        this.setState({ loading: false });
                        this.growl.show({ severity: 'error', summary: null, detail: 'Please Select Family Member' });
                        flag = 1;
                        return;
                    }
                    return (el.fieldDescription === 'Amount in KWD') && el || null;
                }).filter(el => el != null).map(el => Object.assign({}, {
                    amount: parseFloat(el.fieldValue)
                }));
            });

            if (flag === 1) return;

            let totalAmount = parseFloat(0.000);
            let j;
            for (j = 0; j < dummy[0].length; j++) {
                totalAmount += parseFloat(dummy[0][j].amount)
            }

            let error = 0;
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                if (stageIndex === 0) {
                    const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                    const containerGroup = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || [];
                    const fields = containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1] || [];
                    if (fields && fields.length > 0) {
                        let count = stageField.length + 1;
                        let sequence = stageField.length + 1;
                        const newFields = fields.reduce((a, el) => {
                            const startIndex = el.fieldName.substring(0, 10);
                            a.push(Object.assign({}, { ...el }, {
                                fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: field.fieldName, childRowNmbr: Object.keys(containerGroup).length.toString(), fieldValue: (el.fieldType == 1) ? ((field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount : (el.fieldDescription == 'Hotel Expense') ? 0 :
                                    (el.fieldDescription == 'Transportation Expense') ? 0 : (el.fieldDescription == 'Meals Expense') ? 0 : (el.fieldDescription == 'Purchases Expense') ? 0 : (el.fieldDescription == 'Other Expenses') ? 0 : '') : (el.fieldDescription == 'Exchange Rate') ? 0 : ''
                            }));
                            return a;
                        }, []);
                        return Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.concat(newFields) });
                    } else if (location && location.state && location.state.stagesequence === stageIndex) {
                        error = 1;
                        return stage;
                    }
                    else {
                        return stage;
                    }
                } else {
                    return stage;
                }
            });
            j = 0;

            //  const initialValuesWithUpdatedTotal = this.setFieldValueUsingFieldId("cb9b05b4-d11d-4521-ac3d-74d82bf726f7", InitialValues, totalAmount)

            const initialValuesWithUpdatedTotal = this.setFieldValueUsingFieldidrownum("cb9b05b4-d11d-4521-ac3d-74d82bf726f7", InitialValues, totalAmount, cldr)




            setTimeout(() => {
                try {

                    if (error) {
                        this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
                        return;
                    }

                    this.setState({ loading: false, process: initialValuesWithUpdatedTotal });

                    //this.setState({ loading: false });
                    //this.setState({ loading: false, process: InitialValues });
                    //this.setState({ loading: false }, { process: process });

                }

                catch (error) {
                    //handleExpectedError(error);
                    this.setState({ error: error });
                }

            }, 3000);

        }

        catch (error) {
            //handleExpectedError(error);
            this.setState({ error: error });
        }

        //i = 0;

        // this.setState({
        //     process: this.state.process.filter((p,i) => i <= 20  ).map(stage => Object.assign({}, { ...stage }, {
        //         stage_Field: stage
        //             .stage_Field.map(field => {
        //                 return Object.assign({}, { ...field }, { fieldValue:  field.fieldDescription === 'Total Amount in KWD' && totalAmount ? totalAmount  : field.fieldValue })
        //             })
        //     }))
        // });


        // this.setState({
        //     process: this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue:  (field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount: field.fieldValue })) }))
        // });
    }

    handleAttachment = (data, type) => {
        let index = 0;
        let attachmentData = data.map((el) => {
            index++
            return {
                Requestattachmentid: '00000000-0000-0000-0000-000000000000',
                Requestid: '00000000-0000-0000-0000-000000000000',
                SiNo: index,
                UploadPath: el.filePath,
                FileName: el.fileName,
                Extension: el.fileExtension,
                Createdby: this.props.loggedUserDetail.empID,
                Createddate: moment().format('MM/DD/YYYY'),
                Updatedby: this.props.loggedUserDetail.empID,
                Updateddate: moment().format('MM/DD/YYYY'),
                CompanyId: this.props.loggedUserDetail.CompanyId,
                Stagenum: 0,
            }
        });
        this.setState({ requestattachments: attachmentData });
    }

    initialize = (process, type, field) => {
        const { tableLists, location = {} } = this.props;
        const { stageSequence } = this.state;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith


        let count = 1;
        let sequence = 1;
        if (type === 'progress' || type === 'add' || type === 'edit') {
            this.setState({ process: [], loading: true });

            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (type === 'add' && el.parentFieldId === '000' && el.fieldType != '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        } else if (type === 'add' && el.fieldType === '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const fields = stageField.filter(_ => _.parentFieldId === el.fieldName);
                            const lastItem = a[a.length - 1];
                            fields.map((subField) => {
                                a.push(Object.assign({}, { ...subField }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName, childRowNmbr: '0' }));
                            })
                        } else if (type === 'edit') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const lastItem = a[a.length - 1];
                            if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                el.stage_FieldsList.map((subField, subIndex) => {
                                    if (subIndex != 0) {
                                        subField.stage_FieldsListc2.map(c2 => {
                                            a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName }));
                                        })
                                    }
                                })
                            }
                        }
                        return a;
                    }, [])
                })
            });

            setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);
        } else {

            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }

    }


    generatePayslip = (type) => {
        this.setState({ loading: true });
        this.handlePayslipInPdf(type);
    }

    resolveEmployeeLabel = (employeeId) => {
        if (employeeId == null || employeeId === '') {
            return '';
        }

        const {
            metaData = {},
            loggedUserDetail = {},
            Employee = []
        } = this.props;

        const employeeOptions = [
            ...(metaData['Request For'] || []),
            ...(metaData['Requested For'] || []),
            ...(Employee || [])
        ];

        const employee = employeeOptions.find(option => {
            if (!option) return false;

            return (
                String(option.value || '').toLowerCase() === String(employeeId).toLowerCase() ||
                String(option.id || '').toLowerCase() === String(employeeId).toLowerCase() ||
                String(option.uniqueId || '').toLowerCase() === String(employeeId).toLowerCase()
            );
        });

        if (employee) {
            return (
                employee.label ||
                employee.text ||
                employee.name ||
                employee.userName ||
                employee.employeeName ||
                employeeId
            );
        }

        if (
            loggedUserDetail.empID &&
            String(loggedUserDetail.empID).toLowerCase() === String(employeeId).toLowerCase()
        ) {
            return loggedUserDetail.userName || employeeId;
        }

        return employeeId;
    };

    // Resolves ID/value to its corresponding Label for PDF display.
    resolveFieldDisplayValue = (field) => {
        const { metaData = {} } = this.props;

        if (!field) {
            return '';
        }

        const fieldValue = field.fieldValue;

        if (fieldValue == null || fieldValue === '') {
            return '';
        }

        let options = metaData[field.fieldDescription] || [];
        if (options.length === 0 && /supplier/i.test(field.fieldDescription || '')) {
            options = metaData['Preferred Supplier'] || metaData['Select Supplier'] || [];
        }

        const findLabel = (val) => {
            const matchedOption = options.find(option => {
                if (!option) return false;
                return (
                    String(option.value != null ? option.value : '').toLowerCase() === String(val).toLowerCase() ||
                    String(option.id != null ? option.id : '').toLowerCase() === String(val).toLowerCase() ||
                    String(option.uniqueId != null ? option.uniqueId : '').toLowerCase() === String(val).toLowerCase()
                );
            });
            return matchedOption ? (matchedOption.label || matchedOption.text || matchedOption.name || val) : null;
        };

        // MultiSelect fields (fieldType '3') store their value as a comma-separated list of
        // option values, same convention used by MultiSelectBox on the Process page, so each
        // token is resolved to its label individually and rejoined for display.
        if (field.fieldType === '3') {
            const labels = String(fieldValue).split(',').map(v => v.trim()).filter(v => v).map(v => findLabel(v) || v);
            return labels.join(', ');
        }

        const matchedLabel = findLabel(fieldValue);
        if (matchedLabel != null) {
            return matchedLabel;
        }

        if (field.fieldType === '7' || field.fieldType === '8') {
            return moment(fieldValue).format('DD/MM/YYYY');
        }

        return fieldValue;
    };


    handlePayslipInPdf = (type) => {
        try {
            const { process } = this.state;
            const { location = {}, tableLists = {}, loggedUserDetail = {}, containerData } = this.props;
            const { state = {} } = location;

            const templateStages =
                (containerData &&
                    Object.keys(containerData).length > 0 &&
                    containerData.stage) || [];

            let fullProcess = [];

            if (
                tableLists &&
                Array.isArray(tableLists.requestAttribute1) &&
                tableLists.requestAttribute1.length > 0
            ) {
                fullProcess = tableLists.requestAttribute1;
            } else if (Array.isArray(process) && process.length > 0) {
                fullProcess = process.concat(
                    templateStages.filter(
                        (c, i) => i > (process.length - 1)
                    )
                );
            } else {
                fullProcess = templateStages;
            }

            // Header fields: top-level (non-container) fields across every completed stage
            const headerFields = process.reduce((fields, stage) => {
                return fields.concat((stage.stage_Field || []).filter(field => field.parentFieldId === '000' && field.fieldType !== '9'));
            }, []);

            // Line items: fieldType '9' containers, grouped by childRowNmbr, excluding the trailing in-progress row
            let lineItemColumns = [];
            let lineItemRows = [];
            process.forEach(stage => {
                (stage.stage_Field || []).filter(field => field.fieldType === '9').forEach(containerField => {
                    const groupFields = (stage.stage_Field || []).filter(field => field.parentFieldId === containerField.fieldName);
                    const grouped = lodash.groupBy(groupFields, 'childRowNmbr');
                    const rowKeys = Object.keys(grouped);
                    const committedRowKeys = rowKeys.filter((key, i) => i !== rowKeys.length - 1);
                    if (committedRowKeys.length === 0) { return; }

                    const columnFields = grouped[rowKeys[rowKeys.length - 1]] || grouped[committedRowKeys[0]] || [];
                    if (lineItemColumns.length === 0) {
                        lineItemColumns = columnFields.map(field => field.fieldDescription);
                    }

                    committedRowKeys.forEach(key => {
                        const row = grouped[key];
                        lineItemRows.push(columnFields.map(colField => {
                            const match = row.find(r => r.fieldDescription === colField.fieldDescription);
                            return match ? this.resolveFieldDisplayValue(match) : '';
                        }));
                    });
                });
            });

            // Approval History: parsed from each subsequent stage's description (skips the initial/request stage)
            const processArray = fullProcess.slice(1);

            const approvalHistoryRows = [];

            processArray.forEach((item, index) => {

                let employeeNumber = '';
                let employeeName = '';
                let position = '';
                let dateAndTime = 'Pending';

                const description = item.description || '';

                if (description && description.includes(',')) {

                    const parts = description
                        .split(',')
                        .map(part => part.trim());

                    employeeNumber = (parts[0] || '')
                        .replace(/^[^:]+:\s*/, '')
                        .trim();

                    employeeName = ((parts[1] || '')
                        .split('-')[0] || '')
                        .trim();

                    position = (parts[2] || '').trim();

                    const parsedDateAndTime = (parts[3] || '')
                        .replace(/^[^:]+:\s*/, '')
                        .trim();

                    if (parsedDateAndTime) {
                        dateAndTime = parsedDateAndTime;
                    }
                }

                approvalHistoryRows.push([
                    index + 1,
                    employeeNumber,
                    employeeName,
                    position,
                    dateAndTime
                ]);
            });

            const requestNum = state.requestNum || (tableLists && tableLists.requestNum) || 'MarketingCampaign';

            // Request For: convert Employee ID to Employee Label/Name.
            const requestedForField = headerFields.find(
                field =>
                    field.fieldDescription === 'Requested For' ||
                    field.fieldDescription === 'Request For'
            );

            const requestedFor = requestedForField
                ? this.resolveEmployeeLabel(requestedForField.fieldValue)
                : '';

            // Created By must always match the Request For name shown elsewhere in the PDF.
            const createdBy = requestedFor;

            // const printedBy = (loggedUserDetail && (loggedUserDetail.userName || loggedUserDetail.empID)) || '';
            const printedBy = String(
                (this.props.userPosInfo && this.props.userPosInfo.userName)
                || (loggedUserDetail && loggedUserDetail.userName)
                || ''
            ).trim();
            const printedOn = moment().format('DD/MM/YYYY HH:mm');

            // Voucher Details laid out as one row (Request Num + every header field), same structure as Line Items
            // The Comment field is intentionally excluded from the PDF.
            const pdfHeaderFields = headerFields.filter(field => String(field.fieldDescription || '').trim().toLowerCase() !== 'comment');
            const headerColumns = ['Request Num', ...pdfHeaderFields.map(field => field.fieldDescription)];

            const headerValues = [
                requestNum,
                ...pdfHeaderFields.map(field => {
                    if (
                        field.fieldDescription === 'Request For' ||
                        field.fieldDescription === 'Requested For'
                    ) {
                        return this.resolveEmployeeLabel(field.fieldValue);
                    }

                    return this.resolveFieldDisplayValue(field);
                })
            ];
            var doc = new jsPDF('p', 'mm', 'a4', 3);

            doc.autoTable({
                theme: 'plain',
                didDrawCell: function (data) {
                    if (data.column.index === 0 && data.cell.section === 'body') {
                        doc.addImage(chenthoorLandscapeLogo, 'PNG', data.cell.x, data.cell.y - 3, 40, 20);
                    }
                },
                startY: 9,
                margin: { left: 8.5 },
                columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 200 } },
                body: [[
                    { content: "", styles: { cellPadding: 0, borderColor: 'white' } },
                    { content: "CHENTHOOR RESTAURANT", styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fontSize: 14, textColor: 'black', cellPadding: { top: 5, left: 6, right: 0 }, borderColor: 'white' } }
                ]]
            });

            let previousTableEnding = doc.lastAutoTable.finalY;

            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 10,
                margin: { left: 5 },
                tableWidth: 200,
                body: [[
                ]]
            });

            previousTableEnding = doc.lastAutoTable.finalY;

            doc.setFontSize(12);
            doc.text('Campaign Details:', 5, previousTableEnding + 14);

            // Split Campaign Details across two rows: first half of fields, then the remaining half
            const headerMidpoint = Math.ceil(headerColumns.length / 2);
            const headerColumnsRow1 = headerColumns.slice(0, headerMidpoint);
            const headerValuesRow1 = headerValues.slice(0, headerMidpoint);
            const headerColumnsRow2 = headerColumns.slice(headerMidpoint);
            const headerValuesRow2 = headerValues.slice(headerMidpoint);

            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 18,
                styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                alternateRowStyles: { fillColor: [255, 255, 255] },
                tableLineColor: [0, 0, 0],
                tableLineWidth: 0.1,
                margin: { left: 5 },
                tableWidth: 200,
                head: [headerColumnsRow1],
                body: [headerValuesRow1],
            });

            previousTableEnding = doc.lastAutoTable.finalY;

            if (headerColumnsRow2.length > 0) {
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding,
                    styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    alternateRowStyles: { fillColor: [255, 255, 255] },
                    tableLineColor: [0, 0, 0],
                    tableLineWidth: 0.1,
                    margin: { left: 5 },
                    tableWidth: 200,
                    head: [headerColumnsRow2],
                    body: [headerValuesRow2],
                });

                previousTableEnding = doc.lastAutoTable.finalY;
            }

            if (lineItemRows.length > 0) {
                doc.setFontSize(12);
                doc.text('Menu Items:', 5, previousTableEnding + 14);
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 18,
                    styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    alternateRowStyles: { fillColor: [255, 255, 255] },
                    tableLineColor: [0, 0, 0],
                    tableLineWidth: 0.1,
                    margin: { left: 5 },
                    tableWidth: 200,
                    head: [lineItemColumns],
                    body: lineItemRows,
                });
                previousTableEnding = doc.lastAutoTable.finalY;
            }

            if (approvalHistoryRows.length > 0) {
                doc.setFontSize(12);
                doc.text('Approval History:', 5, previousTableEnding + 14);
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 18,
                    styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    alternateRowStyles: { fillColor: [255, 255, 255] },
                    tableLineColor: [0, 0, 0],
                    tableLineWidth: 0.1,
                    margin: { left: 5 },
                    tableWidth: 200,
                    head: [['S.No', 'Employee Number', 'Employee Name', 'Position', 'Date & Time']],
                    body: approvalHistoryRows,
                });
                previousTableEnding = doc.lastAutoTable.finalY;
            }

            // Footer (Created By / Printed By / Printed On) added to every page
            const totalPages = doc.internal.getNumberOfPages();
            for (let pageIndex = 1; pageIndex <= totalPages; pageIndex++) {
                doc.setPage(pageIndex);
                doc.setFontSize(8);
                doc.setTextColor(0, 0, 0);
                doc.text(`Created By: ${createdBy}     Printed By: ${printedBy}     Printed On: ${printedOn}`, 5, 292);
            }

            if (type === 'print') {
                doc.autoPrint();
                window.open(doc.output('bloburl'), requestNum);
                this.setState({ loading: false, payslipGenerated: true });
            } else if (type === 'view') {
                window.open(doc.output('bloburl'), requestNum);
                this.setState({ loading: false, payslipGenerated: true });
            } else if (type === 'download') {
                doc.save(`${requestNum}.pdf`);
                this.setState({ loading: false, payslipGenerated: true });
            }
        } catch (error) {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'Failed to generate PDF' });
        }
    }
    // Names of the fields in each container's current input row (the last child row) that hold a
    // value the user typed but has not yet added with the Add button. Read from state.process only.
    getUnaddedFieldNames = () => this.getUnaddedContainers().reduce((names, c) => names.concat(c.fieldNames), []);

    // Containers (by their own fieldDescription) whose input row holds unadded values.
    getUnaddedContainers = () => {
        const { process, stageSequence } = this.state;
        const containers = [];
        (process || []).filter((p, i) => i <= parseInt(stageSequence)).forEach(stage => {
            const stageFields = stage.stage_Field || [];
            stageFields.filter(el => el.fieldType === '9' && el.parentFieldId === '000').forEach(container => {
                const grouped = lodash.groupBy(stageFields.filter(_ => _.parentFieldId === container.fieldName), 'childRowNmbr');
                const rowKeys = Object.keys(grouped);
                if (rowKeys.length === 0) {
                    return;
                }
                const fieldNames = [];
                grouped[rowKeys[rowKeys.length - 1]].forEach(el => {
                    const isTime = [1, 7, 8].includes(parseInt(el.fieldType)) && isTimeField(el);
                    if (el.disabled || !el.fieldDescription || !(isTime || ImplementationFor[parseInt(el.fieldType)])) {
                        return;
                    }
                    const val = el.fieldValue;
                    const isEmpty = val === null || val === undefined || (Array.isArray(val) ? val.length === 0 : String(val).trim() === '' || Number(val) === 0 && !isNaN(Number(val)));
                    if (!isEmpty) {
                        fieldNames.push(el.fieldName);
                    }
                });
                if (fieldNames.length > 0) {
                    containers.push({ name: container.fieldDescription, fieldNames });
                }
            });
        });
        return containers;
    }

    // Yes on the unadded-data popup: clear only the input-row values, then continue the save/submit.
    handleClearUnaddedAndProceed = () => {
        const submitType = this.state.unaddedDataSubmitType;
        const unadded = this.getUnaddedFieldNames();
        const cleared = this.state.process.map(stage => Object.assign({}, stage, {
            stage_Field: (stage.stage_Field || []).map(f => unadded.includes(f.fieldName) ? Object.assign({}, f, { fieldValue: '' }) : f)
        }));
        this.setState({ process: cleared, unaddedDataSubmitType: false }, () => this.saveRequest(submitType, true));
    }

    saveRequest = (submitType, skipUnaddedCheck) => {
        if ((submitType === 'save' || submitType === 'submit') && skipUnaddedCheck !== true && this.getUnaddedFieldNames().length > 0) {
            this.setState({ unaddedDataSubmitType: submitType });
            return;
        }
        const { containerData } = this.props;
        const { process } = this.state;
        const type = this.props.match.params.type;
        let requestNumber = (this.props.location && this.props.location.state && this.props.location.state.requestNum) || '';
        let loggedUserEmpId = this.props.loggedUserDetail.empID;


        let RequestAttributes = [];
        let Comment = '';
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {

                //         if (el.fieldDescription === 'Comment' && stageIndex === 0) {
                //             Comment = el.fieldValue;
                //         }
                //         if(el.fieldDescription === 'Expense Type' && stageIndex === 0){
                //             RequestType = el.fieldValue;
                //         }

                RequestAttributes.push(Object.assign({}, { ...el }, { fieldValue: (el.fieldType === "7" || el.fieldType === "8") ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue }));
            })
        });

        if (submitType === 'save' || submitType === 'submit') {
            const missingFields = [];
            // Only stages shown on screen (same filter the render uses)
            process.filter((p, i) => i <= parseInt(this.state.stageSequence)).forEach(stage => {
                (stage.stage_Field || []).forEach(el => {
                    if (el.fieldStatus !== 'Required' || el.parentFieldId !== '000' || el.fieldType === '9') {
                        return;
                    }
                    // Only validate fields that are actually rendered on the form (same check Inputs uses)
                    const isTime = [1, 7, 8].includes(parseInt(el.fieldType)) && isTimeField(el);
                    if (!el.fieldDescription || !(isTime || ImplementationFor[parseInt(el.fieldType)])) {
                        return;
                    }
                    const val = el.fieldValue;
                    const isEmpty = val === null || val === undefined || (Array.isArray(val) ? val.length === 0 : String(val).trim() === '');
                    if (isEmpty && !missingFields.includes(el.fieldDescription)) {
                        missingFields.push(el.fieldDescription);
                    }
                });
            });
            // Containers without at least one saved row (the last child row is the input row, not a saved one)
            const emptyContainers = [];
            process.filter((p, i) => i <= parseInt(this.state.stageSequence)).forEach(stage => {
                (stage.stage_Field || []).filter(el => el.fieldType === '9' && el.parentFieldId === '000').forEach(container => {
                    const grouped = lodash.groupBy((stage.stage_Field || []).filter(_ => _.parentFieldId === container.fieldName), 'childRowNmbr');
                    const rowKeys = Object.keys(grouped);
                    if (rowKeys.length === 0 || rowKeys.length > 1) {
                        return;
                    }
                    const requiredNames = [];
                    arraySort(grouped[rowKeys[0]], 'fieldSequence').forEach(sub => {
                        const isTime = [1, 7, 8].includes(parseInt(sub.fieldType)) && isTimeField(sub);
                        if (sub.fieldStatus !== 'Required' || !sub.fieldDescription || !(isTime || ImplementationFor[parseInt(sub.fieldType)])) {
                            return;
                        }
                        if (!requiredNames.includes(sub.fieldDescription)) {
                            requiredNames.push(sub.fieldDescription);
                        }
                    });
                    if (requiredNames.length > 0) {
                        emptyContainers.push({ name: container.fieldDescription, fields: requiredNames });
                    }
                });
            });

            if (missingFields.length > 0 || emptyContainers.length > 0) {
                const lines = [];
                if (missingFields.length > 0) {
                    lines.push(`Please fill in the following required fields: ${missingFields.join(', ')}.`);
                }
                if (emptyContainers.length > 0) {
                    lines.push('Please add at least one row with the following required fields in each container:');
                }
                this.setState({ requiredFieldsMessage: lines.join('\n'), requiredFieldsContainers: emptyContainers });
                return;
            }
        }

        let data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Opening Stock',
            IsActive: true,
            RequestDate: moment().format('MM/DD/YYYY'),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: CAMPAIGN_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'RMC';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'RMC';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'RMC';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
                model = 'RMC';
            }


            if (type === 'edit') {
                data.requestId = this.state.requestId
            }
            // if (this.state.requestId) {
            //     data.requestId = this.state.requestId
            // }

            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });

            // if(requestNumber && submitType == 'submit'){//checking whether the request is in the requester stage or approver stage
            //     let generatedPdf = this.handlePayslipInPdf('upload', loggedUserEmpId.toUpperCase());
            //     axios.post(`/master/api/Base4ToPDF`, generatedPdf)
            //         .then(response => {
            //             if(response.status == 200){
            //                 axios.post(url, JSON.stringify(datas))// triggering the submit/save of a request
            //                     .then(response => {
            //                         this.setState({ loading: false });
            //                         if (submitType === 'submit' || submitType === 'return') {
            //                             if (response.status === 200) {
            //                                 if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
            //                                     let submitValue = response.data.result && JSON.parse(response.data.result);
            //                                     let tableValue = [];
            //                                     if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
            //                                         tableValue = submitValue.Table.map(list => {
            //                                             return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
            //                                         })
            //                                     }
            //                                     if(submitType === 'submit'){
            //                                         this.setState({dialogBoxText: "Select Supervisor"})
            //                                     }
            //                                     if(submitType === 'return'){
            //                                         this.setState({dialogBoxText: "Return To", popupType:'return'})
            //                                     }
            //                                     this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
            //                                 } else {
            //                                     this.growl.show({ severity: 'success', summary: null, detail: 'Visitor Gate-Pass Request submitted successfully' });
            //                                     this.props.history.push('/dashboard');
            //                                 }
            //                             } else {
            //                                 this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
            //                             }

            //                         } else {
            //                             this.growl.show({ severity: 'success', summary: null, detail: 'Visitor Gate-Pass Request saved successfully' });
            //                             this.props.history.push('/dashboard');
            //                         }

            //                     })
            //                     .catch(err => {
            //                         this.setState({ loading: false })
            //                         this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
            //                     })
            //             }

            //         }).catch(err => {
            //             this.growl.show({ severity: 'error', summary: null, detail: 'File Upload API Failed. Please Approve again' });
            //             this.setState({ loading: false });
            //         })
            // } else 
            {
                axios.post(url, JSON.stringify(datas))
                    .then(response => {

                        this.setState({ loading: false });
                        if (submitType === 'submit' || submitType === 'return') {
                            if (response.status === 200) {
                                if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                    let submitValue = response.data.result && JSON.parse(response.data.result);
                                    let tableValue = [];
                                    if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                        tableValue = submitValue.Table.map(list => {
                                            return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO, Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID }
                                        })
                                    }
                                    if (submitType === 'submit') {
                                        this.setState({ dialogBoxText: "Select Supervisor" })
                                    }
                                    if (submitType === 'return') {
                                        this.setState({ dialogBoxText: "Return To", popupType: 'return' })
                                    }
                                    this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                                } else {
                                    this.growl.show({ severity: 'success', summary: null, detail: 'Employee Loan Request submitted successfully' });
                                    this.props.history.push('/dashboard');
                                }
                            } else {
                                this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                            }

                        } else {
                            this.growl.show({ severity: 'success', summary: null, detail: 'Employee Loan Request saved successfully' });
                            this.props.history.push('/dashboard');
                        }

                    })
                    .catch(err => {
                        this.setState({ loading: false })
                        this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                    })
            }

        }

    }

    componentDidMount() {
        const { getContainerData, getKeywordValues, getMasterKeywordList, location = {}, loggedUserDetail } = this.props;
        const type = this.props.match.params.type;
        // this.effectiveDateHandler()
        getContainerData(CAMPAIGN_ID);//Get Container Data
        // getKeywordValues('Employee');//Get Employee Dropdown list
        // getMasterKeywordList('Employee,Branch,Store,Ingredient');//Get Employee

        getMasterKeywordList('Employee');//Get Nationality Dropdown list 
        getMasterKeywordList('StorageLocation');//Get Nationality Dropdown list 
        getMasterKeywordList('Ingredient');//Get Nationality Dropdown list 
        getMasterKeywordList('Branch');//Get Nationality Dropdown list 
        getMasterKeywordList('Period');//Get Nationality Dropdown list 
        getMasterKeywordList('Invostype');//Get Nationality Dropdown list 
        getMasterKeywordList('UOM'); //Get Nationality Dropdown list
        getMasterKeywordList('Invstoragelocation');//Get Nationality Dropdown list 
        getMasterKeywordList('nationality');//Get Nationality Dropdown list 
        getMasterKeywordList('OrgUnit');
        getMasterKeywordList('LOANTYPE');//Get Loan Type Dropdown list
        getMasterKeywordList('salarytypen');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('MenuItem');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('vendor');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('Priority');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('RequestSource');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('Modifier');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('Kitchen');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('OrderType');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('WeekDays');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('PromotionType');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('CustomerType');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('DiscountType');//Get Deduction Frequency Dropdown list
        getMasterKeywordList('InvRestriction');//Get Deduction Frequency Dropdown list
        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists, containerData } = this.props;
            const type = this.props.match.params.type;
            let requestattachments = tableLists.requestattachments || [];
            this.setState({ requestattachments });

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || false;
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || false;
            }

            if (process && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                clearTimer();
            }
        }, 300);

    }


    render() {
        const { tableLists, location = {}, metaData = {} } = this.props;
        const { state = {} } = location;
        const { process, stageSequence, currentSequence, editing, editSnapshot } = this.state;
        const pendingWith = location && location.state && location.state.pendingWith;
        const actionRowStyle = { display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' };

        const pageType = this.props.match.params.type;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const dialogDynamicFooter = (
            <div style={actionRowStyle}>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary" />
            </div>
        );
        let a;
        {
            a = process.filter((p, i) => i <= parseInt(stageSequence));
        }


        return (

            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {(this.props.error !== null || this.state.error) && <Messages type="error" message={this.props.error || this.state.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            Marketing Campaign
                            <Link to={'/marketingcampaign'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>



                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');

                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {(stageField || []).map((field, fieldIndex) => {
                                    const containerGroup = field.fieldType === '9' && lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || false;
                                    const containerFields = (containerGroup && Object.keys(containerGroup).length > 0 && editing && editing.parentFieldId === field.fieldName && containerGroup[editing.childRowNmbr]) || (containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1]) || [];
                                    const containerTable = containerGroup && Object.keys(containerGroup).length > 0 && Object.keys(containerGroup).filter((g, i) => i != Object.keys(containerGroup).length - 1).reduce((tableRow, row) => {
                                        const displayFields = (editing && editSnapshot && editing.parentFieldId === field.fieldName && String(editing.childRowNmbr) === String(row)) ? editSnapshot : containerGroup[row];
                                        const rowFields = displayFields.reduce((r, c) => {
                                            const DropdownValues = metaData[c.fieldDescription] && c.fieldValue && metaData[c.fieldDescription].find(_ => _.value === c.fieldValue) || false;
                                            return Object.assign({}, { ...r }, { [c.fieldDescription.replaceAll(' ', '_')]: (DropdownValues && DropdownValues.label) || ((c.fieldType === '7' || c.fieldType === '8') && moment(c.fieldValue).format('MM/DD/YYYY')) || c.fieldValue, childRowNmbr: c.childRowNmbr, parentFieldId: c.parentFieldId })
                                        }, {});
                                        tableRow.push(Object.assign({}, rowFields, { stage_Field: displayFields }));
                                        return tableRow;
                                    }, []) || [];

                                    return field.parentFieldId === "000" ? <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : "p-col-12 p-md-6 p-lg-4"}>
                                        {field.fieldType != "9" ? <Inputs
                                            field={Object.assign({}, { ...field }, { disabled: field.fieldDescription === 'Installment Amount' ? true : field.disabled, dateFormat: (field.fieldDescription === 'Repayment Start Month' || field.fieldDescription === 'Repayment End Month') ? 'mm/yy' : undefined, view: (field.fieldDescription === 'Repayment Start Month' || field.fieldDescription === 'Repayment End Month') ? 'month' : undefined })}
                                            value={field.fieldType === '3' && field.fieldValue ? field.fieldValue.split(",") : field.fieldValue}
                                            process={process}
                                            onInputChange={(e) => field.fieldType === '3' ? this.handleMultiSelectChange(e, field) : this.handleChange(e, field)}
                                            {...this.props}
                                            {...this.state} /> :
                                            field.fieldType === '9' ?
                                                <Fieldset legend={field.fieldDescription} toggleable collapsed={this.state[field.fieldName] === undefined ? true : this.state[field.fieldName]} onToggle={(e) => this.setState({ [field.fieldName]: e.value })} style={{ border: this.state[field.fieldName] === undefined || this.state[field.fieldName] ? 'none' : '1px solid rgba(0, 0, 0, 0.38)' }}>
                                                    <div className="p-grid">
                                                        {containerFields.map((subField, subIndex) => <div key={subIndex} className={"p-col-12 p-md-6 p-lg-4"}><Inputs
                                                            field={Object.assign({}, { ...subField }, { disabled: subField.fieldDescription === 'Installment Amount' ? true : subField.disabled, dateFormat: (subField.fieldDescription === 'Repayment Start Month' || subField.fieldDescription === 'Repayment End Month') ? 'mm/yy' : undefined, view: (subField.fieldDescription === 'Repayment Start Month' || subField.fieldDescription === 'Repayment End Month') ? 'month' : undefined })}
                                                            value={subField.fieldType === '3' && subField.fieldValue ? subField.fieldValue.split(",") : subField.fieldValue}
                                                            process={process}
                                                            onInputChange={(e) => subField.fieldType === '3' ? this.handleMultiSelectChange(e, subField) : this.handleChange(e, subField)}
                                                            {...this.props}
                                                            {...this.state} /></div>
                                                        )}
                                                        <div className="p-col-12 p-md-6 p-lg-4">
                                                            {editing && editing.parentFieldId === field.fieldName ? <div className="mt2" style={{ padding: '8px' }}>
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-pencil" onClick={this.updateEdit} label="Update" style={{ marginRight: '10px' }} />
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" onClick={this.cancelEdit} label="Cancel" />
                                                            </div> : <div className="mt2" style={{ padding: '8px' }}>
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-plus" onClick={() => this.handleContainer(field)} label="Add" />
                                                            </div>}
                                                        </div>
                                                        <div className="p-col-12">
                                                            <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}
                                                                expandableRowGroups={false} expandedRows={this.state.expandedRows} onRowToggle={(e) => { this.setState({ expandedRows: e.data }) }}
                                                                rowExpansionTemplate={this.rowExpansionTemplate}
                                                                dataKey="childRowNmbr" rows={10} value={containerTable}>
                                                                <Column expander={true} style={{ width: '3em' }} />
                                                                {containerFields.map((columnField, columnIndex) =>
                                                                    (pageType == 'edit' & columnField.fieldDescription == 'Original Currency') ? <Column key={columnIndex} field={columnField.fieldDescription.replaceAll(' ', '_')} header={columnField.fieldDescription} body={this.currencyNameRender} /> : <Column key={columnIndex} field={columnField.fieldDescription.replaceAll(' ', '_')} header={columnField.fieldDescription} />
                                                                )}
                                                                {
                                                                    ((pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null)) ? null : <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                                                                }
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                                </Fieldset> : null}
                                    </div> : null

                                })}


                                {/* {( stage.stageNum == '000' || stage.stageSequence == 0)  ? 
                                <div className="p-col-12 p-md-12 p-lg-12">
                                     <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'VisitorPass'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     /> 
                                </div> 
                                    :
                                 null} */}

                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" style={actionRowStyle}>
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" /> */}
                                        <Link to={'/materialpass-in'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :

                                    <div className="p-col-12 p-md-12 p-lg-12" style={actionRowStyle}>
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary" label="Save" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Submit" icon="pi pi-save" />
                                        <Button disabled={status && status === 'Closed' && pendingWith === 'Closed' ? false : true} className="p-button-danger" label="Cancel" onClick={() => this.saveRequest('cancel')} />
                                        <Button onClick={() => this.generatePayslip('download')} className="p-button-success" label="Download PDF" icon="pi pi-file-pdf" />
                                        {/* <Button onClick={() => this.generatePayslip('view')} className="p-button-success ml1" label="View Payslip" icon="pi pi-save" /> */}
                                        {/* <Button /*disabled={this.state.payslipGenerated == false? true : false} onClick={() => this.setState({ payslipDisplay: true})} className="p-button-success ml1" label="View Payslip" icon="pi pi-save" /> */}
                                        {/* {((status && status === 'Closed') && (pendingWith && pendingWith === 'Closed')) ? <Button disabled={this.state.payslipGenerated == false? true : false} onClick={() => this.generatePayslip('download')} className="p-button-success ml1" label="Download Loan Request as PDF" icon="pi pi-save" /> : null} */}
                                        {/* {((status && status === 'Closed') && (pendingWith && pendingWith === 'Closed')) ? */}
                                        {/* // <Button disabled={this.state.payslipGenerated == false? true : false} onClick={() => this.generatePayslip('print')} className="p-button-success ml1" label="Print Loan Request" icon="pi pi-save" />: null} */}
                                        <Link to={'/marketingcampaign'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}
                            </div>
                        </div>
                    </div>
                })}


                <Dialog header="Confirmation" visible={!!this.state.unaddedDataSubmitType} modal={true} style={{ width: '450px' }} closable={true}
                    footer={<div>
                        <Button label="Yes" icon="pi pi-check" className="p-button-primary" onClick={this.handleClearUnaddedAndProceed} />
                        <Button label="No" icon="pi pi-times" className="p-button-secondary" onClick={() => this.setState({ unaddedDataSubmitType: false })} />
                    </div>}
                    onHide={() => this.setState({ unaddedDataSubmitType: false })}>
                    <p style={{ fontWeight: 'normal' }}>You have entered data in the <b>{this.state.unaddedDataSubmitType ? this.getUnaddedContainers().map(c => c.name).filter((n, i, arr) => arr.indexOf(n) === i).join(', ') : ''}</b> container fields but have not clicked the Add button. Do you want to clear the entered data and proceed with Save and Submit?</p>
                </Dialog>

                <Dialog header="Required Fields" visible={!!this.state.requiredFieldsMessage} modal={true} style={{ width: '400px' }} closable={true}
                    footer={<Button label="Close" icon="pi pi-times" className="p-button-secondary" onClick={() => this.setState({ requiredFieldsMessage: '', requiredFieldsContainers: [] })} />}
                    onHide={() => this.setState({ requiredFieldsMessage: '', requiredFieldsContainers: [] })}>
                    <p style={{ whiteSpace: 'pre-line', fontWeight: 'normal' }}>{this.state.requiredFieldsMessage}</p>
                    {(this.state.requiredFieldsContainers || []).map((c, i) => (
                        <p key={i} style={{ margin: '0.25em 0', fontWeight: 'normal' }}><span style={{ fontWeight: 'bold' }}>{c.name}</span>: <span style={{ fontWeight: 'normal' }}>{c.fields.join(', ')}</span></p>
                    ))}
                </Dialog>

                <Dialog header={this.state.dialogBoxText} visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.dialogBoxText}<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.dialogBoxText} name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }







}

const mapStateToProps = state => {
    const Employee = (state.keyword.Employee !== undefined) ? state.keyword.Employee : [];
    const loggedUserDetail = state.auth.userObject || {};
    const subordinatesListData = state.master.subordinatesListData;
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { value: el.uniqueId }));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName}-Self`, value: state.auth.userObject.empID, id: parseInt(state.auth.userObject.userID) })]);

    let relevantOptions = [];
    let countryList = state.master.Country || [];
    const hrTeam = parseInt(localStorage.getItem('hrTeam'));
    if (hrTeam) {
        relevantOptions = Employee.reduce((a, el) => {
            if (el.value !== loggedUserDetail.empID) {
                a.push(el);
            }
            return a;
        }, [Object.assign({}, Employee.find(list => list.value === loggedUserDetail.empID), { label: 'Self', id: loggedUserDetail.userID })]);
    } else {
        relevantOptions = (loggedUserDetail !== null) ? [{ label: `${loggedUserDetail.userName}(Self)`, value: loggedUserDetail.empID, id: loggedUserDetail.userID }].concat(subordinatesListData) : subordinatesListData;
    }
    return {
        loggedUserDetail,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData,
        Employee,
        EmployeeList: relevantOptions,
        currencyList: currencyList && currencyList || [],
        keywordValuesList,
        metaData: Object.assign({}, {
            "Requested For": relevantOptions,
            "Ingredient": state.keyword.Ingredient,
            "Store": state.keyword.StorageLocation,
            "Invetory Period": state.keyword.Period,
            "Opening Type": state.keyword.Invostype,
            "Base UOM": state.keyword.UOM,
            "Storage Location": state.keyword.Invstoragelocation,
            "Currency": currencyList && currencyList || [],
            "Loan Type": state.keyword.LOANTYPE || [],
            "Deduction Frequency": state.keyword.salarytypen || [],
            "Outlets": state.keyword.Branch || [],
            "Fiscal Year": year || [],
            "Menu Item": state.keyword.MenuItem || [],
            "UOM": state.keyword.UOM,
            "Preferred Supplier": state.keyword.vendor || [],
            "Priority": state.keyword.Priority || [],
            "Request Source": state.keyword.RequestSource || [],
            "Modifier": state.keyword.Modifier || [],
            "Required Time": state.keyword.Modifier || [],
            "Order Source": state.keyword.Modifier || [],
            "Order Type": state.keyword.OrderType || [],
            "Business Partner Type": state.keyword.Modifier || [],
            "Name": state.keyword.Modifier || [],
            "Delivery Method": state.keyword.Modifier || [],
            "Delivery Partner": state.keyword.Modifier || [],
            "Payment Term": state.keyword.Modifier || [],
            "Payment Status": state.keyword.Modifier || [],
            "Production Plan Id": state.keyword.Modifier || [],
            "KitchenId": state.keyword.Kitchen || [],
            "Kitchen Station Id": state.keyword.Modifier || [],
            "Reference": state.keyword.Modifier || [],
            "Applicable Days": state.keyword.WeekDays || [],
            "Promotion Type": state.keyword.PromotionType || [],
            "Customer Type Eligibility": state.keyword.CustomerType || [],
            "Discount Type": state.keyword.DiscountType || [],
            "Inventory Restriction": state.keyword.InvRestriction || [],

        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(MarketingCampaign)